import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepTwoGroups.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getGroupsData = createSelector(
  (state) => state.memoryStepTwoGroups.data.memoryStepTwoGroups,
  (groups = []) => groups
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepTwoGroups.data.currency,
  (currency = {}) => currency
);

export default {
  getCurrencyData,
  getGroupsData,
  getHasLoaded,
};
